module.exports = __webpack_public_path__ + "static/media/Pewters Avenue.5fdc33df.jpg";